import { environment } from '@environments/environment';

export enum PortalCommunicationOperator {
  GlobalConnectSe = 'GLOBALCONNECT_SE',
  GlobalConnectFi = 'GLOBALCONNECT_FI',
}

export function isGlobalConnect(): boolean {
  return (
    location.hostname === environment.globalConnectSe.selfserviceHost ||
    location.hostname === environment.globalConnectFi.selfserviceHost
  );
}

export function isGlobalConnectFinland(): boolean {
  return location.hostname === environment.globalConnectFi.selfserviceHost;
}

export function isGlobalConnectSweden(): boolean {
  return location.hostname === environment.globalConnectSe.selfserviceHost;
}

export function getCurrentPortalCommunicationOperator(): PortalCommunicationOperator {
  if (isGlobalConnectFinland()) {
    return PortalCommunicationOperator.GlobalConnectFi;
  }
  return PortalCommunicationOperator.GlobalConnectSe;
}

export function getPortalPublicWebUrl(): string {
  return environment[
    isGlobalConnectSweden() ? 'globalConnectSe' : 'globalConnectFi'
  ].publicWebHost;
}

export function getPortalCustomerServiceNumber(): string {
  if (isGlobalConnectFinland()) {
    return environment.globalConnectFi.customerServicePhoneNumber;
  }
  return environment.globalConnectSe.customerServicePhoneNumber;
}
